import template from './template.html'

(function (angular) {

  angular
    .module('contabilidad.cheques')
    .config(Config)

  Config.$inject = ['$stateProvider']

  function Config ($stateProvider) {
    $stateProvider.state('contabilidad.cheques', {
      url: '/cheques?:ID_Empresa&{fecha_inicio:date}&{fecha_fin:date}&:CuentaBancaria',
      reloadOnSearch: false,
      template,
      data: {
        title: 'Cheques',
      },
      controllerAs: '$ctrl',
      controller: Controller,
    })
  }

  Controller.$inject = ['$q', '$stateParams', 'ContabilidadCheques', '$catalogos', '$location', '$moment']

  function Controller ($q, $stateParams, ContabilidadCheques, $catalogos, $location, $moment) {
    var $ctrl = this
    $ctrl.obtenerCheques = obtenerCheques
    $ctrl.exportar = exportar
    $ctrl.data = undefined

    $ctrl.opciones = {
      fecha_inicio: $stateParams['fecha_inicio'] || $moment().startOf('month').toDate(),
      fecha_fin: $stateParams['fecha_fin'] || $moment().endOf('month').toDate(),
      ID_Empresa: $stateParams['ID_Empresa'] || undefined,
      CuentaBancaria: $stateParams['CuentaBancaria'] || undefined,
    }

    $q.all({
      empresas: ContabilidadCheques.obtenerEmpresasClientes(),
      cuentasBancarias: $catalogos.get('cuentasBancarias'),
    }).then(function ($resolve) {
      $ctrl.empresas = $resolve.empresas
      $ctrl.cuentasBancarias = $resolve.cuentasBancarias
    })

    if ($ctrl.opciones.ID_Empresa && $ctrl.opciones.CuentaBancaria)
      obtenerCheques()

    function obtenerCheques () {
      ContabilidadCheques
        .obtenerCheques($ctrl.opciones)
        .then(function (data) {
          $ctrl.data = data
          $location.search({
            fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
            fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
            ID_Empresa: $ctrl.opciones.ID_Empresa,
            CuentaBancaria: $ctrl.opciones.CuentaBancaria,
          })
        })
    }

    function exportar () {
      ContabilidadCheques
        .exportarXLS($ctrl.data, 'Chueques_Cta' + $ctrl.opciones.CuentaBancaria)
    }
  }
})
(window.angular)



// WEBPACK FOOTER //
// ./src/contabilidad/cheques/components/component.js